import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

function getDaysInMonth(month, year) {
  const date = new Date(year, month, 0);
  const monthName = date.toLocaleDateString('en-US', {
    month: 'short',
  });
  const daysInMonth = date.getDate();
  const days = [];
  let i = 1;
  while (days.length < daysInMonth) {
    days.push(`${monthName} ${i}`);
    i += 1;
  }
  return days;
}

function AreaGradient({ color, id }) {
  return (
    <defs>
      <linearGradient id={id} x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor={color} stopOpacity={0.3} />
        <stop offset="100%" stopColor={color} stopOpacity={0} />
      </linearGradient>
    </defs>
  );
}

AreaGradient.propTypes = {
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

function StatCard({ title, value, interval, trend, bgColor, borderColor, icon, dialogTitle, dialogContent, showDialog = false }) {
  const theme = useTheme();
  const daysInWeek = getDaysInMonth(4, 2024);
  const [open, setOpen] = React.useState(false);

  const handleCardClick = () => {
    if (showDialog) setOpen(true);
  };

  const trendColors = {
    up:
      theme.palette.mode === 'light'
        ? theme.palette.success.main
        : theme.palette.success.dark,
    down:
      theme.palette.mode === 'light'
        ? theme.palette.error.main
        : theme.palette.error.dark,
    neutral:
      theme.palette.mode === 'light'
        ? theme.palette.grey[400]
        : theme.palette.grey[700],
  };

  const labelColors = {
    up: 'success',
    down: 'error',
    neutral: 'default',
  };

  const color = labelColors[trend];
  const chartColor = trendColors[trend];
  const trendValues = { up: '+25%', down: '-25%', neutral: '+5%' };

return (
  <>
    <Card variant='outlined' onClick={handleCardClick} sx={{ borderRadius: '16px', height: '100%', flexGrow: 1, backgroundColor: bgColor, border: borderColor }}>
        <CardContent>
            <Stack direction="row" alignItems="center" spacing={2}>
                {icon && icon}
                <Stack spacing={0.5}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="h4" component="p">
                        {value}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        {interval}
                    </Typography>
                </Stack>
            </Stack>
        </CardContent>
    </Card>
    {showDialog && (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent>{dialogContent}</DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Fermer</Button>
          </DialogActions>
        </Dialog>
      )}
      </>
);
}

StatCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  interval: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  trend: PropTypes.oneOf(['down', 'neutral', 'up']).isRequired,
  value: PropTypes.string.isRequired,
};

export default StatCard;